import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Imoveis from "@/pages/Imoveis";
import ImovelDetalhe from "@/pages/ImovelDetalhe";
import Sobre from "@/pages/Sobre";
import Contato from "@/pages/Contato";
import { AuthProvider } from "@/lib/auth";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminImoveis from "@/admin/AdminImoveis";
import AdminImovelForm from "@/admin/AdminImovelForm";
import AdminLeads from "@/admin/AdminLeads";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

const SiteLayout = ({ children }) => (
  <>
    <Navbar />
    {children}
    <Footer />
  </>
);

const Shell = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  useEffect(() => {
    if (isAdmin) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, [isAdmin]);

  return (
    <>
      <ScrollManager />
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/imoveis" replace />} />
          <Route path="imoveis" element={<AdminImoveis />} />
          <Route path="imoveis/novo" element={<AdminImovelForm />} />
          <Route path="imoveis/:id/editar" element={<AdminImovelForm />} />
          <Route path="leads" element={<AdminLeads />} />
        </Route>
        <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
        <Route path="/imoveis" element={<SiteLayout><Imoveis /></SiteLayout>} />
        <Route path="/imoveis/:slug" element={<SiteLayout><ImovelDetalhe /></SiteLayout>} />
        <Route path="/sobre" element={<SiteLayout><Sobre /></SiteLayout>} />
        <Route path="/contato" element={<SiteLayout><Contato /></SiteLayout>} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <div className="min-h-screen bg-obsidian text-[#F4F4F6]">
      <div className="grain-overlay" aria-hidden="true" />
      <AuthProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
